import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { VALIDATE_REFERRAL, ENCRYPT_VALIDATE_REFERRAL } from '../config/app-settings.config';
import { EncrDecrService } from './encr-decr-service.service';

@Injectable({
  providedIn: 'root'
})
export class ValidateReferralService {
  tokenVal: any = sessionStorage.getItem('jwt');

  constructor(private http: HttpClient,
    private encryptDecService: EncrDecrService) { }

  validateReferralCode(validateRefObj) {
    validateRefObj = ENCRYPT_VALIDATE_REFERRAL ? this.encryptDecService.set(validateRefObj): validateRefObj;
    let httpOptions: any;
    httpOptions = {
      headers: new HttpHeaders({
       Authorization: "Bearer " + this.tokenVal,
       withCredentials: "true",
        "Content-Type": "application/json"
      }),
      responseType: 'text'
    };
    return this.http.post(VALIDATE_REFERRAL, validateRefObj, httpOptions);
  }
}
